import { NavigationMenu } from "radix-ui";
import { FC } from "react";
import { useFontStyle } from "~/hook/useFontStyle";
import useAuthRoute from "~/hook/useAuthRoute";
import { cn } from "~/lib/utils";
import { PropsType } from "../mobile-menu/type";
import { wantsDesktop } from "~/utils/helper-funcations";

export const GRID_ITEMS: Record<string, string> = {
  narrow: "grid-cols-1",
  wide: "grid-cols-2",
};

const TextItem: FC<PropsType> = ({ data, category_name, displayItem }) => {
  // const { LocalizedLink } = useLocale();
  const { medium, regular } = useFontStyle();
  const { handleNavigate } = useAuthRoute();
  return (
    <div className={cn("menu_parent_card bg-white h-auto pb-2", displayItem === "wide" ? "w-[320px]" : "w-[250px]", category_name ? "pt-4" : "pt-2")}>
      {category_name && (
        <div className="flex items-center justify-between mb-2">
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}

      <div className={cn("grid gap-0", GRID_ITEMS[displayItem])}>
        {data.map((item) => {
          const isVisible = wantsDesktop(item.show_menu);
          return (
            isVisible && (
              <NavigationMenu.Link asChild key={item.id}>
                <div
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                  className={cn("group flex items-center px-1 py-2 rounded-md transition-colors", "hover:bg-white hover:text-black")}
                >
                  <p className={cn("icon_category_name !text-start", regular)}>{item.name}</p>
                </div>
              </NavigationMenu.Link>
            )
          );
        })}
      </div>
    </div>
  );
};

export default TextItem;
